import { ReactNode } from "react";

import type { ShellView } from "@buildpy/core/views/w0a/shell";
import { logout } from "@/api/actions/org";
import AnnouncementBanner from "@/components/announcement-banner";
import { OrgBlockedNotice, OrgReadOnlyBanner } from "@/components/org-access-notice";
import OrgRejectedScreen from "@/modules/onboarding/ui/org-rejected-screen";
import UsageBanner from "@/modules/plan/ui/usage-banner";
import AppShell from "@/shell/app-shell";
import { CrumbProvider } from "@/shell/crumb";

// 셸 데이터는 route loader 가 view("shell") 로 읽어 내려준다 — 조직 이름·배지·공지는 저장 뒤 무효화(D5) 때 따라온다.
const AppLayout = ({ shell, children }: { shell: ShellView; children: ReactNode }) => {
  const access = shell.orgAccess;
  // 사용량은 대표에게만 실린다(shell view) — 없으면 띠도 없다.
  const usage = shell.planUsage ?? null;
  if (access?.level === "blocked" && access.rejected) return <OrgRejectedScreen reason={access.rejectReason} onLogout={logout} />;
  if (access?.level === "blocked") return <OrgBlockedNotice status={access.status} access={access} onLogout={logout} />;
  return (
    <CrumbProvider>
      <AppShell badges={shell.navBadges} member={shell.member} orgName={shell.orgName} plan={shell.plan ?? null} onLogout={logout}>
        {shell.announcements?.length ? <AnnouncementBanner announcements={shell.announcements} className="mb-4" /> : null}
        {access?.level === "read_only" && <OrgReadOnlyBanner daysLeft={access.daysLeft ?? 0} className="mb-4" />}
        {usage && shell.member.role === "owner" && <UsageBanner className="mb-4" usage={usage} />}
        {children}
      </AppShell>
    </CrumbProvider>
  );
};

export default AppLayout;
